export default "__VITE_ASSET__9wuYaDyh__"